import React from 'react';
import { StarIcon } from 'lucide-react';
type StarsProps = {
  count: number;
  label: string;
  size?: 'sm' | 'md';
};
export function Stars({
  count,
  label,
  size = 'sm'
}: StarsProps) {
  const cls = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  return <span className="flex" role="img" aria-label={`${count} ${label}`} data-id="element-397" data-mp="6wcrdwub8ccf">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className={`${cls} fill-champagne text-champagne`} aria-hidden="true" data-id="element-398" data-mp="3ta4kpcnbdc6v" data-mpi={i} />)}
    </span>;
}